// Custom travel-inspired brand illustrations (orange + emerald family, transparent background).
const P = "https://static.prod-images.emergentagent.com/jobs/7f8760a5-417f-4002-8e15-560ebde22584/images";

export const ILL = {
  // Legacy set (kept for other pages that still reference them)
  compass: `${P}/d64cabd7ff2eeba80a2c6a027cb8e4606c01032a7a9bc22aa0a88dc2dfb4b4d0.png`,
  map: `${P}/9761a120d617be0940b245fd59b2abef607bba78b74b5754901716e5a77cf364.png`,
  wallet: `${P}/239ad9ca0b3068088382604280960913528fd30e65e179adb65332f603eb419a.png`,
  backpack: `${P}/159c990b3f8e5ce78db1d26a7b9bdd78d25715de8c67d16836129c5205707b6c.png`,
  plane: `${P}/16a2147c75e4eb92a91e7cd997a1c04de7b45080675da24da882887138662ae6.png`,
  passport: `${P}/b64d9ba05bb8f0b52fb59735ac24195b48cbe697638143506b4e4e287b300337.png`,
  globe: `${P}/deaba02c9d5d6ec0b25a686f3212a075856408cc9a57691998c96cd5c0d63a88.png`,
  camera: `${P}/f668a1640ce96f18b0103c1f0ed226c6b7327e6a739b48de874dce5de73b09f6.png`,

  // PART 4 — coherent editorial illustration family (transparent, processed locally)
  featBudget: "/ill/feat_budget.png",
  featItinerari: "/ill/feat_itinerari.png",
  featEsperienze: "/ill/feat_esperienze.png",
  featAutonomi: "/ill/feat_autonomi_v2.png",
  cardOrganizza: "/ill/card_organizza.png",
  cardItinerari: "/ill/card_itinerari.png",
  cardBudget: "/ill/card_budget.png",
  cardTips: "/ill/card_tips.png",
  cardGuide: "/ill/card_guide.png",

  // Feature-strip premium icons (orange + cream, high contrast on green)
  icBudget: "/ill/ic_budget.png",
  icItinerari: "/ill/ic_itinerari.png",
  icEsperienze: "/ill/ic_esperienze.png",
  icAutonomi: "/ill/ic_autonomi.png",

  // PART 5 — roadmap step illustrations (transparent)
  stepDestinazione: "/ill/step_destinazione.png",
  stepPeriodo: "/ill/step_periodo.png",
  stepVoli: "/ill/step_voli.png",
  stepAlloggio: "/ill/step_alloggio.png",
  stepItinerario: "/ill/step_itinerario.png",
  stepAttivita: "/ill/step_attivita.png",
  stepDocumenti: "/ill/step_documenti.png",
  stepParti: "/ill/step_parti.png",
};
